module.exports = __webpack_public_path__ + "media/images/gallery/constellations/gal_layer_on-26e6c428916d3ec0fa9901c6cdfb162b.jpg";